<template>
  <div v-loading="loading">
    <el-form label-width="180px">
      <el-form-item :label="$t('fabric.domainProductCode')">
        <MDinput v-model="fabric.code" style="width:80%" :maxlength="16" />
      </el-form-item>
      <el-form-item :label="$t('fabric.description')">
        <MDinput v-model="fabric.description" style="width:80%" :maxlength="32" />
        <div v-if="!fabric.description" class="error">{{ $t('validation.required') }}</div>
      </el-form-item>
      <el-form-item :label="$t('fabric.productType')">
        <Select
          v-model="fabric.productTypeID"
          :required="true"
          :placeholder="$t('fabric.productType')"
          :options="productTypes"
          value-field="id"
          label-field="description"
        />
        <div v-if="!fabric.productTypeID" class="error">{{ $t('validation.required') }}</div>
      </el-form-item>
      <el-form-item :label="$t('fabric.hasPattern')">
        <DSESwitch v-model="fabric.isPatterned" label="test" active-text="common.yes" inactive-text="common.no" />
      </el-form-item>
      <el-form-item :label="$t('fabric.patternHeight')">
        <input-number v-model="fabric.patternHeightInMm" :disabled="!fabric.isPatterned" :step="1" />
        <div v-if="fabric.isPatterned && !fabric.patternHeightInMm" class="error">{{ $t('validation.required') }}</div>
      </el-form-item>
      <el-form-item :label="$t('fabric.fabricWidth')">
        <input-number v-model="fabric.widthInCm" :step="1" :precision="0" />
        <div v-if="!fabric.widthInCm" class="error">{{ $t('validation.required') }}</div>
      </el-form-item>
      <editor-button
        style="margin-top:20px;float:right"
        :icon-only="false"
        :disabled="!canSave"
        action="save"
        button-translation="common.save"
        @click="saveFabric"
      />
      &nbsp;
    </el-form>
    &nbsp;
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import Select from '@/components/DSE/Select';
import MDinput from '@/components/MDinput';
import DSESwitch from '@/components/DSE/Switch';
import InputNumber from '@/components/DSE/InputNumber';
import { ProductTypeOption } from '@/utils/constants';

export default {
  name: 'CompleteOrderPickList',
  components: {
    EditorButton,
    Select,
    MDinput,
    DSESwitch,
    InputNumber
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      errorMsg: '',
      order: {},
      consumer: {},
      dialogVisible: false,
      fabric: this.newFabric()
    };
  },
  computed: {
    canSave() {
      const fabric = this.fabric;
      return (
        fabric.description &&
        fabric.productTypeID &&
        fabric.widthInCm &&
        (!fabric.isPatterned || fabric.patternHeightInMm)
      );
    },
    productTypes() {
      return this.$store.getters['productType/loadedItems'];
    }
  },
  watch: {},
  created() {
    const params = {
      query: {
        productTypeOption: ProductTypeOption.Fabric
      }
    };
    this.$store.dispatch('productType/getItems', params);
  },
  methods: {
    getFabricTypeOption() {
      const productTypeID = this.fabric.productTypeID;
      const productTypes = this.$store.getters['productType/loadedItems'];
      if (productTypeID && productTypes) {
        const productType = productTypes.find(item => item.id === productTypeID);
        return productType && productType.fabricTypeOption;
      } else {
        return undefined;
      }
    },
    newFabric() {
      return {
        isPatterned: false,
        widthInCm: 0
      };
    },
    saveFabric() {
      this.loading = true;
      this.$store
        .dispatch('interiorDecoratorOrder/saveFabric', this.fabric)
        .then(data => {
          this.fabric.id = data;
          this.fabric.productTypeDescription = this.productTypes.find(
            pt => pt.id === this.fabric.productTypeID
          ).description;
          this.fabric.type = this.getFabricTypeOption();
          this.$emit('closeDialogue', this.fabric);
          this.fabric = this.newFabric();
        })
        .catch(() => {
          this.$store.dispatch('notify/dataSaveError');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.error {
  color: red;
}
</style>
